import { NetworkService } from '@/services/NetworkService'

interface IYear {
  id: number
  year: number
}

export class Year implements IYear {

  id!: number
  year!: number

  constructor (params: IYear) { 
    Object.assign(this, params)
  }

  public static async getYearsForMake(makeId: string) {

    let res = await NetworkService.get(
      process.env.VUE_APP_API_BASE_URL +
      "/api/v1/years" + "?makeId=" + makeId
    )

    let ret : Year[] = []

    res.data.forEach( (y : any) => {
      let year : Year = new Year(y)
      ret.push(year)
    })

    return ret
  }
}
